import { Security } from '@blk/awt-aladdinportfoliobuilderserver';
import { isNil } from 'lodash';

export const extractMultiplierFromSecurity = (security: Security | null): number => {
  if (security?.valuations) {
    if (!isNil(security.valuations.notionalMultiplier)) {
      return security.valuations.notionalMultiplier;
    }
    if (!isNil(security.valuations.quantityToMVMultiplier) && !isNil(security.valuations.quantityToNMVMultiplier)) {
      return security.valuations.quantityToMVMultiplier / security.valuations.quantityToNMVMultiplier;
    }
  }
  return 1;
};

/**
 * Determines if FX notional values should be hidden based on configuration flag.
 *
 * @param showFXForwardsNotionalMV - Flag to show/hide FX forward notional MV (true = show, false/undefined = hide)
 * @param security - Security object to check asset type
 * @returns true if the value should be hidden (FX security when flag is false/undefined)
 */
export const shouldHideFXNotionalValue = (
  showFXForwardsNotionalMV: boolean | undefined,
  security: Security | null | undefined
): boolean => {
  if (showFXForwardsNotionalMV) {
    return false;
  }
  return security?.assetType === 'FX';
};

/**
 * Determines the appropriate aggregation function for notional market values.
 *
 * @param disableNotionalMvAggregation - When true, disables all aggregation
 * @param showFXForwardsNotionalMV - When true, includes FX forwards in aggregation
 * @returns 'sum' (include all), 'customSumExcludingFX' (exclude FX), or null (disabled)
 */
export const getNotionalMarketValueAggFunc = (
  disableNotionalMvAggregation: boolean | undefined,
  showFXForwardsNotionalMV: boolean | undefined
): 'sum' | 'customSumExcludingFX' | null => {
  if (disableNotionalMvAggregation) {
    return null;
  }
  if (showFXForwardsNotionalMV) {
    return 'sum';
  }
  return 'customSumExcludingFX';
};
